import Route from '@ember/routing/route';

export default class SchemaRoute extends Route {
  queryParams = {
    personType: {
      refreshModel: true,
      as: 'type',
    },
  };
}
